import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const lettersPath =
    'M17.8728 9.3595L15.9722 3.41636C15.9598 3.3766 15.935 3.34186 15.9014 3.3173C15.8677 3.29274 15.8271 3.27966 15.7855 3.28001H14.1617C14.0757 3.28001 14.0023 3.33455 13.975 3.41636L12.0597 9.3595C12.0534 9.37838 12.0492 9.39936 12.0492 9.42034C12.0492 9.52733 12.1373 9.61544 12.2443 9.61544H13.4275C13.5156 9.61544 13.5911 9.5567 13.6163 9.47279L13.9834 8.18052H15.8505L16.2134 9.47069C16.2365 9.5546 16.3141 9.61334 16.4022 9.61334H17.6861C17.7071 9.61334 17.7259 9.61124 17.7448 9.60495C17.7952 9.58817 17.835 9.5546 17.8602 9.50845C17.8833 9.4623 17.8875 9.40985 17.8728 9.3595ZM14.1743 7.08756L14.8624 4.6352H14.9946L15.668 7.08756H14.1743ZM17.1847 17.4277H14.4659V17.4193L17.2476 13.4566C17.2707 13.423 17.2833 13.3852 17.2833 13.3433V12.5797C17.2833 12.4727 17.1952 12.3846 17.0882 12.3846H12.8086C12.7016 12.3846 12.6135 12.4727 12.6135 12.5797V13.4817C12.6135 13.5887 12.7016 13.6768 12.8086 13.6768H15.3806V13.6852L12.5884 17.648C12.5651 17.6812 12.5526 17.7208 12.5527 17.7613V18.5249C12.5527 18.6319 12.6408 18.72 12.7478 18.72H17.1826C17.2896 18.72 17.3777 18.6319 17.3777 18.5249V17.6228C17.378 17.5973 17.3732 17.572 17.3636 17.5483C17.354 17.5247 17.3399 17.5032 17.3219 17.485C17.304 17.4669 17.2826 17.4525 17.2591 17.4426C17.2355 17.4328 17.2102 17.4277 17.1847 17.4277Z';

const arrowPath =
    'M8.98639 14.9859H7.39204V3.8674C7.39204 3.77509 7.31652 3.69957 7.22421 3.69957H6.04943C5.95712 3.69957 5.8816 3.77509 5.8816 3.8674V14.9859H4.28725C4.14669 14.9859 4.06698 15.1495 4.15509 15.2586L6.50466 18.2354C6.52035 18.2555 6.54041 18.2717 6.56331 18.2828C6.58621 18.294 6.61135 18.2998 6.63682 18.2998C6.66229 18.2998 6.68743 18.294 6.71033 18.2828C6.73322 18.2717 6.75328 18.2555 6.76898 18.2354L9.11855 15.2586C9.20456 15.1495 9.12694 14.9859 8.98639 14.9859Z';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    sort: { id: 'lblIconSort', defaultMessage: 'Sort' },
});

const SortIcon = React.memo(function SortIcon(props: TSortIconProps): React.ReactElement {
    const { sortOrder, ...elementProps } = props;

    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.sort)} {...elementProps}>
            <path d={lettersPath} />
            <path d={arrowPath} transform={sortOrder === 'asc' ? 'rotate(180, 6.6, 11)' : undefined} />
        </IconBase>
    );
});

export default SortIcon;

// #region Types

export type TSortIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>> & {
        sortOrder?: 'asc' | 'desc';
    };

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <SortIcon /> : { ...IconBaseExample, render: SortIcon };

// #endregion
